import { Breadcrumbs } from '../../Breadcrumbs'

import { FileDirectoryBreadcrumb } from './FileDirectoryBreadcrumb'

import * as styles from './FileDirectoryBreadcrumbs.module.css'

function FileDirectoryBreadcrumbs(props) {
  return (
    <Breadcrumbs
      {...props}
      Item={FileDirectoryBreadcrumb}
      skeletonClassName={styles.skeleton}
    />
  )
}

export default FileDirectoryBreadcrumbs
